import styled from "styled-components";

const CardContentSquares = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 2px 0;
    @media(max-width: 400px){
        flex-direction: column;
    }
`;

export default CardContentSquares;
